import axios from 'axios'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import { toast } from 'react-toastify'
import GlobalFooter from './GlobalFooter'

function AccountInfo() {
    const phone = localStorage.getItem("phone")
    const fullName = localStorage.getItem("fullName")
    const record = JSON.parse(localStorage.getItem("auth"))
    const [isLoading,setIsLoading] = useState(false)
    const navigate = useNavigate();



    const handleClose = ()=>{
        navigate("/pages/global-payment")
    }


    const creatLink =async()=>{
        setIsLoading(true)
        try{
            const payload ={
                phoneNumber:phone,
                fullName:fullName
            }

            console.log("payload: ",payload)
            const url = "https://1mgy6330f9.execute-api.us-east-2.amazonaws.com/production/ui-data-params"

            const res = await axios.post(url,payload)


            // console.log("result: ",res.data)
            const {status} =  res.data || ''
            if(status ==='completed'){
                navigate('/pages/select-account')
            }else{
                const {link_token} = res.data.data;
                setIsLoading(false)
                navigate('/pages/link',{state:{link_token}})
            }

        }catch(err){
            setIsLoading(false)
            console.log(err)
            const errorMessage = err.response?.data?.message || "An Unexpected error has occured: try again"
            toast.error(errorMessage)
        }
    }
  return (
    <div className='global_layout'>
        {/* {
                 record?.avatar ?
                 <div className='img_container'>
                     <img className='img_glob' src={record?.avatar} alt=''/>
                 </div>:
                <div className='glob_avater custom_avater'>
                    <p className='glob_avater_text'>{String(record?.data?.business_name).slice(0, 1)}</p>
                </div>
        } */}
    
        <div className='global_container'>
            <div className='top_bar'>
                <img src='/images/global/arrow-left.svg' alt='' onClick={handleClose}/>
                <img src='/images/global/close.svg' alt='' onClick={handleClose}/>
            </div>

            <div className='global_content'>
                <div className='glob_avater'>
                        {
                            record?.avatar ?
                            
                            <img className='img_avater' src={record?.avatar} alt='' />:
                            
                            <p className='glob_avater_text'>{String(record?.data?.business_name).slice(0,1)}</p>
                        }
                </div>
                <p className='glob_title'>Payment information</p>
                <p className='glob_desc'>Your data is encrypted and your details will not be accessible to Superwallet</p>
                <div className='amount_content'>
                    <div className='name_amount'>
                        <img src='/images/global/briefcase.svg' alt=''/> 
                        <p className='glob_name'>Balance</p>
                    </div>
                    <h6 className='name_value'>{record?.payableFxAmountString}</h6>
                </div>
                <div className='amount_pattern'>
                    <p className='glob_name' style={{marginTop:"10px"}}>Amount</p>
                    <p className='glob_amount_value'>{record?.payableFxAmountString}</p>
                </div>
                {/* Phone Number */}
               
                <button className='btn' style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"center",marginTop:"18px",gap:"8px",background:"#228985",borderRadius:"10000px"}} onClick={creatLink} disabled={isLoading}>
                {isLoading ? (
                            <BeatLoader
                                color="#FFF"
                                cssOverride={{}}
                            />              ) : (
                            <>   
                               
                               <p>Continue</p>
                               <img src='/images/global/activeArrow.svg' alt='' />
                            </>
                        )}
                </button>

            </div>
        </div>
        {
            !record?.total_whitelabelling &&
            <GlobalFooter />
        }
    </div>
  )
}

export default AccountInfo